// TODO: how to give prop typing here?

import React, { useState, useEffect, useRef } from 'react';
import { View } from 'react-native';
import PropTypes from 'prop-types';
import { useStore } from 'Store';
import {
    isArchive,
    isLiveTv,
    isRecording,
    isSeries,
    isVod,
    isEpisode,
    itemHasEnded,
    ITEM_TYPES
} from 'Utils/index';
import { Background, ActivityIndicator } from 'LocalGluons';
import { getRecSeriesItem } from 'Pages/Details/detailsUtils';
import { Device } from 'DeviceUtils';
import { useRoute, CommonActions } from '@react-navigation/native';
import { useAppErrorHandler } from '../../App/AppErrorHandlerContext/AppErrorHandlerContext';
import { useNavigationPropsContext } from '../../Navigation/navigationPropsContext';

const MINIMUM_FETCH_INTERVAL = 5000;
export const withItemUpdater =
    (Component, showBackground = true, isPopup = false) =>
    (props) => {
        const { navigation, style, cell } = props;
        const route = useRoute();
        const { navigationProps, updateNavigationProps } = useNavigationPropsContext();
        const [state, setState] = useState({ item: null });
        const [loading, setLoading] = useState(true);
        const [playouts, setPlayouts] = useState(null);
        const [entitlements, setEntitlements] = useState(null);
        const [nativeEntitlements, setNativeEntitlements] = useState(null);

        const { appManager, mySubscriptions } = useStore();
        const { setError } = useAppErrorHandler();
        const [itemLoaded, setItemLoaded] = useState(false);
        const prevLiveItem = useRef(null);
        const fetchDate = useRef(null);

        const supportedPlatforms = ['VOYO'];
        const isLowLatency = route.params?.lowLatency ?? props?.lowLatency ?? false;

        const updateItem = async (_item) => {
            setItemLoaded(false);
            let updateFailed = false;
            const updatedItem = _item;
            let playoutResponse = null;
            let entitlementsResponse = null;
            let nativeEntitlementsResponse = null;
            const isRecordingType = isRecording(_item);
            const isRecordingSeries = _item?.modelType === ITEM_TYPES.RECORDING_SERIES;
            const platform = _item?.data?.pckg?.platform;
            setLoading(true);
            try {
                if (isLiveTv(_item) || isArchive(_item) || isRecordingType) {
                    const isPrevItemRelevant =
                        !!prevLiveItem.current &&
                        prevLiveItem.current.data.end > new Date().getTime();

                    if (!isPrevItemRelevant) prevLiveItem.current = _item;
                    // Recording needs data like Program but treated as recording type
                    if (isRecordingType && itemHasEnded(updatedItem)) {
                        updatedItem.modelType = ITEM_TYPES.RECORDING;
                    }
                } else if (isVod(_item) && supportedPlatforms.includes(platform)) {
                    const {
                        backstageConnector: { vod }
                    } = appManager.getApi();
                    try {
                        playoutResponse = await vod.getPlayouts(platform);
                        const packageIds = [];
                        mySubscriptions.packages.forEach((subscriptionPackage) => {
                            if (subscriptionPackage.platform === platform) {
                                packageIds.push(
                                    ...subscriptionPackage.items.map((packageItem) =>
                                        packageItem.id.toString()
                                    )
                                );
                            }
                        });
                        entitlementsResponse = await vod.getMovieEntitlements(
                            platform,
                            _item.getId(),
                            packageIds,
                            mySubscriptions.subscriberType
                        );
                    } catch {
                        console.log(Error);
                    }
                } else if (isVod(_item) || isEpisode(_item)) {
                    const {
                        backstageConnector: { vod }
                    } = appManager.getApi();
                    try {
                        const packageIds = [];
                        mySubscriptions.packages.forEach((subscriptionPackage) => {
                            subscriptionPackage.items.forEach((packageItem) => {
                                if (packageItem.type === 'VOD') {
                                    packageIds.push(packageItem.id.toString());
                                    // packageItem.id.toString();
                                }
                            });
                        });
                        nativeEntitlementsResponse = await vod.getMovieNativeEntitlements(
                            _item.getId(),
                            packageIds,
                            mySubscriptions.subscriberType
                        );
                    } catch {
                        console.log(Error);
                    }
                } else if (_item?.modelType === ITEM_TYPES.CONTINUE_WATCHING) {
                    /* else if (isRecordingSeries) {
                    console.log('if 4');
                    // updatedItem = await getRecSeriesItem(
                    //     _item.episodes.map((ep) => ep.data.id),
                    //     _item?.isPlanned()
                    // );
                    console.log('updatedItem', updatedItem);
                    // if (!updatedItem) updateFailed = true;
                } */
                    if (
                        _item.originalModelType === ITEM_TYPES.RECORDING ||
                        _item.originalModelType === ITEM_TYPES.TV
                    ) {
                        // noinspection JSConstantReassignment
                        updatedItem.modelType = _item.originalModelType;
                    }
                }
            } catch (error) {
                setError({ error, screenId: 'detail' });
                console.error(error);
                updateFailed = true;
            } finally {
                if (updateFailed) {
                    // Pop episode detail (1)
                    // Pop episode detail and series detail (2)
                    navigation.pop(isRecordingSeries ? 2 : 1);
                } else {
                    setState({ item: updatedItem });
                    setPlayouts(playoutResponse);
                    setEntitlements(entitlementsResponse);
                    setNativeEntitlements(nativeEntitlementsResponse);
                    setItemLoaded(true);
                }
                setLoading(false);
            }
        };

        const fetchDetail = async (id, platform, type, isPlanned = false) => {
            if (
                fetchDate.current &&
                fetchDate.current.id === id &&
                fetchDate.current.timestamp + MINIMUM_FETCH_INTERVAL > Date.now()
            ) {
                return;
            }

            fetchDate.current = { timestamp: Date.now(), id };
            let asset;
            let series;

            switch (type) {
                case ITEM_TYPES.TV:
                    asset = await appManager.getApi().fetchProgramDetail({
                        scheduleId: id
                    });
                    updateItem(asset);
                    break;
                case ITEM_TYPES.RECORDING_SERIES:
                    asset = await appManager.getApi().fetchAllRecordings({
                        platform: 'iptv,go',
                        planned: isPlanned
                    });
                    asset.items.some((_item) => {
                        if (_item.data.id === id) {
                            updateItem(_item);
                            return true;
                        }
                        return false;
                    });
                    break;
                case ITEM_TYPES.RECORDING:
                    asset = await appManager.getApi().fetchRecordingDetail({
                        scheduleId: id
                    });
                    updateItem(asset);
                    break;
                case ITEM_TYPES.VOD:
                    asset = await appManager.getApi().fetchMovie(id, platform);
                    updateItem(asset);
                    break;
                case ITEM_TYPES.EPISODE:
                    asset = await appManager.getApi().fetchMovie(id, platform);
                    asset.modelType = ITEM_TYPES.EPISODE;
                    updateItem(asset);
                    break;
                case ITEM_TYPES.SEASON:
                    series = await appManager.getApi().fetchSeries(route?.params?.parentId);
                    asset = series
                        .getSeasons()
                        .find((season) => String(season.getId()) === String(id));
                    updateItem(asset);
                    break;
                case ITEM_TYPES.SERIES:
                    asset = await appManager.getApi().fetchSeries(id);
                    updateItem(asset);
                    break;
                case ITEM_TYPES.CONTINUE_WATCHING:
                    asset = await appManager.getApi().fetchProgramDetail({
                        scheduleId: id
                    });
                    updateItem(asset);
                    break;
                default:
            }
        };

        useEffect(() => {
            if (cell) return;
            const platform =
                route?.params?.platform !== 'NATIVE' && route?.params?.platform
                    ? route?.params?.platform
                    : 'GO';
            fetchDetail(route?.params?.id, platform, route?.params?.type, route?.params?.isPlanned);
            const willFocus = navigation.addListener('focus', async () => {
                fetchDetail(
                    route?.params?.id,
                    platform,
                    route?.params?.type,
                    route?.params?.isPlanned
                );
            });
            const willBlur = navigation.addListener('blur', async () => {
                setState({ item: null });
                fetchDate.current = null;
                updateNavigationProps({
                    navigationPickerHeaderIsToggled: false
                });
            });
            return () => {
                if (willFocus) willFocus();
                if (willBlur) willBlur();
            };
        }, [route?.params, cell]);

        useEffect(() => {
            if (!cell) return;
            fetchDetail(cell.data.id, cell.data?.pckg?.platform, cell.modelType);
        }, [cell]);

        const BackgroundComponent = showBackground ? Background : View;
        return (
            <BackgroundComponent style={style}>
                {state.item && (
                    <Component
                        {...props}
                        {...state}
                        isLowLatency={isLowLatency}
                        loading={loading}
                        setLoading={setLoading}
                        updateItem={updateItem}
                        playouts={playouts}
                        entitlements={entitlements}
                        nativeEntitlements={nativeEntitlements}
                        mySubscription={mySubscriptions}
                    />
                )}
                {!state.item && isPopup && <ActivityIndicator isOverlay />}
            </BackgroundComponent>
        );
    };

withItemUpdater.propTypes = {
    navigation: PropTypes.shape({}).isRequired
};
